"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _multiRequestEpic = _interopRequireDefault(require("settings-ui-sdk/multiRequestEpic"));

var _actions = require("settings-ui-sdk/AdsROI/actions");

var _API = _interopRequireDefault(require("settings-ui-sdk/AdsROI/API"));

var _StagingActions = require("../actions/StagingActions");

var _stagingSelectors = require("../selectors/stagingSelectors");

var syncCostPerLeadEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.syncCostPerLead,
  initiatingActionType: _actions.AdsROIActionTypes.SYNC_COST_PER_LEAD,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.SyncCostPerLead
}));
var syncROISettingEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.syncROISetting,
  initiatingActionType: _actions.AdsROIActionTypes.SYNC_ROI_SETTING,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.SyncROISetting
}));
var saveStagedChangesEpic = (0, _multiRequestEpic.default)({
  requestEpics: [syncCostPerLeadEpic, syncROISettingEpic],
  mapStateToInitiatingActions: function mapStateToInitiatingActions(state) {
    return [(0, _actions.syncCostPerLead)((0, _stagingSelectors.getStagedCostPerLead)(state).toJS()), (0, _actions.syncROISetting)((0, _stagingSelectors.getStagedROISetting)(state))];
  },
  metaInitiatingActionType: _StagingActions.StagingActionTypes.SAVE_STAGED_CHANGES,
  metaRequestStatusSelector: _stagingSelectors.getSaveStagedChangesRequestStatus,
  metaRequestActions: _StagingActions.SaveStagedChanges
});
var _default = saveStagedChangesEpic;
exports.default = _default;
module.exports = exports.default;